import { render, staticRenderFns } from "./CuratorDetail.vue?vue&type=template&id=68acda28&scoped=true&"
import script from "./CuratorDetail.vue?vue&type=script&lang=js&"
export * from "./CuratorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68acda28",
  null
  
)

export default component.exports